<template>
  <div>
    <div class="map-area-box" :class="{ 'ui-hide': !mapOperationShow }">
      <div class="map-icon" @click="showOrHideMap(true)" :class="{ 'ui-hide': !uiToggleVar }"></div>
      <div class="map-scale-btn" @click="mapShow = true"></div>
      <div class="map-close-btn" @click="mapOperationShow = !mapOperationShow"></div>
      <div class="map-operation-box">
        <div class="map-operation-btn video-btn"   @click="openSpecialSub"></div>

        <div class="map-operation-btn voice-btn" :class="{'off':!musicPlay}" @click="triggerBgMusic"></div>
        <div class="map-operation-btn share-btn" @click="openShare"></div>
        <div class="map-operation-btn zan-btn">

        </div>
      </div>
    </div>
    <div class="map-open-btn" :class="{'ui-show':!mapOperationShow}" @click="mapOperationShow = !mapOperationShow">

    </div>

    <div class="map-box" v-if="mapShow">
      <div class="map-box-bg" @click.prevent="showOrHideMap(false)"></div>
      <div class="close-map" @click="showOrHideMap(false)"></div>
      <div class="map-content">
        <div class="map-img">
          <div class="map-dot-box">
            <!-- <div
              class="map-dot"
              @click="clickDot(item)"
              :class="{first:activeName.includes(item.name)}"
              v-show="item != dotItem"
              v-for="(item,index) in dotData"
              :key="index"
              :style="{'left':item.left+'rem','top':item.top + 'rem'}"
            ></div> -->
            <div class="map-dot-new" @click="clickDot(item)"
              :class="{'map-dot-white': itemTagName(item.type), 'map-dot-isActived': itemIsActived(item)}"
              v-for="(item,index) in dotDataNew" :key="index" :style="{'left':item.left+'vw', 'top':item.top + 'vw'}">
              <!-- <span class="map-dot-index" v-if="item.type === 'tagname'">{{item.index}}</span>
              <span>{{item.title}}</span> -->
            </div>
          </div>
          <div class="map-local-dot"
            :style="{'left': (isHover ? chosedItem.left :dotItem.left)+ 'vw','top':(isHover ? chosedItem.top : dotItem.top) + 'vw'}"></div>
        </div>
        <div class="map-menu-box">
          <div class="center-menu">
            <div class="center-menu-title" :class="[item.class,{active:dotItem.name == item.name} ]" @click="clickDot(item)" @mouseenter="mouseover(item)"
                  @mouseleave="mouseLeave(item)" v-for="(item,index) in outMenu"
              :key="index"></div>

            <div class="center-menu-title"></div>
            <div class="center-menu-box">
              <el-scrollbar style="height:100%">
                <div class="center-menu-item" @click="clickDot(item)" @mouseenter="mouseover(item)"
                  @mouseleave="mouseLeave(item)" v-for="(item,index) in centerMenu" :class="{active:dotItem.name == item.name}" :key="index">
                  <div class="center-menu-index">{{index + 1}}</div>
                  <div class="center-menu-content">
                    <div class="center-menu-item-title">{{item.title}}</div>
                    <div class="center-menu-item-lable">{{item.label}}</div>
                  </div>
                </div>
              </el-scrollbar>

            </div>
          </div>
          <div class="place-menu">
            <div class="place-menu-title"></div>
            <div class="place-menu-scroll-box">
              <el-scrollbar style="height:100%">
                <div class="place-menu-box">
              <div class="place-menu-item" @click="clickDot(item)" @mouseenter="mouseover(item)"
                  @mouseleave="mouseLeave(item)" v-for="(item,index) in placeMenu" :class="{active:dotItem.name == item.name}" :key="index">
                <div class="place-menu-index">{{index + 13}}</div>
                <div class="place-menu-lable">{{item.title}}</div>
              </div>
            </div>
              </el-scrollbar>
            </div>
            <div class="place-menu-title  " v-for="(item,index) in lastMenu" ::key="index" @click="clickDot(item)" @mouseenter="mouseover(item)"
                  @mouseleave="mouseLeave(item)" :class="[{active:dotItem.name == item.name},item.class]" ></div>
          </div>
        </div>
      </div>

    </div>
    <audio src="" preload id="audio"></audio>
    <div class="qrcode-box" v-if="shareShow">
      <div class="qrcode-bg"></div>
      <div class="qrcode-close" @click="closeShare"></div>
      <div class="qrcode">
        <div class="qrcode-img" ref="qrcode"></div>
        <!-- <img src="../assets/img/ewm.png" class="qrcode-img" alt="" /> -->
        <p class="qrcode-text">
          扫一扫 通过手机打开
        </p>
      </div>
    </div>
    <specialSubject @closeSpecialSub="closeSpecialSub" :showSpecial="showSpecial"></specialSubject>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import QRCode from "qrcodejs2";
import BubbleHearts from "../utils/flutter-hearts-zmt";
import { giveThumbsUp, cityInfo } from "@/utils/tools.js"
import specialSubject from "./specialSubject.vue"
export default {
  props: {
    uiToggleVar: true,
    sceneName: "",
    krpano: ""
  },
  components:{
    specialSubject
  },
  data() {
    return {
      mapShow: false,
      mapOperationShow: true,
      isHover: false,
      chosedItem: "",
      shareShow: false,
      autoView: false,
      timeLine: "",
      audio: "",
      musicPlay: true,
      zanNum: "",
      numShow: false,
      showSpecial:false,
      activeName: [
        "scene_0_1_1",
        "scene_1_1_1",
        "scene_2_1_1",
        "scene_3_1_1",
        "scene_4_1_1",
        "scene_5_1_1",
        "scene_6_1_1",
        "scene_7_1_1",
      ],

      dotDataNew: [

        { name: "scene_0_1_1", active: "0_1", left: "18", top: "17", type: 'tagnamenoicon', title: '序厅' },
        { name: "scene_1_1_0", active: "1_1", left: "17.55", top: "13.85", type: 'tagname', title: '经济', index: 1 },
        { name: "scene_1_2_1", active: "1_2", left: "15.36", top: "9.84", type: 'tagname', title: '改革', index: 2 },
        { name: "scene_1_3_1", active: "1_3", left: "20.73", top: "10.05", type: 'tagname', title: '政治', index: 3 },
        { name: "scene_1_4_1", active: "1_4", left: "20.47", top: "12.71", type: 'tagname', title: '法治', index: 4 },
        { name: "scene_1_5_1", active: "1_5", left: "12.08", top: "16.77", type: 'tagname', title: '文化建设', index: 5 },
        { name: "scene_1_6_1", active: "1_6", left: "8.91", top: "16.77", type: 'tagname', title: '社会建设', index: 6 },
        { name: "scene_1_7_1", active: "1_7", left: "6.04", top: "11.35", type: 'tagname', title: '美丽中国', index: 7 },
        { name: "scene_1_8_1", active: "1_8", left: "13.02", top: "11.35", type: 'tagname', title: '国防和军队', index: 8 },
        { name: "scene_1_9_1", active: "1_9", left: "8.13", top: "9.22", type: 'tagname', title: '国家安全', index: 9 },
        { name: "scene_1_10_1", active: "1_10", left: "7.71", top: "6.09", type: 'tagname', title: '一国两制', index: 10 },
        { name: "scene_1_11_1", active: "1_11", left: "9.48", top: "5.78", type: 'tagname', title: '大国外交', index: 11 },
        { name: "scene_1_12_1", active: "1_12", left: "11.15", top: "7.40", type: 'tagname', title: '从严治党', index: 12 },

        { name: "scene_2_1_1", active: "2_1", left: "15.36", top: "7.50", type: 'cityname', title: '北京' },
        { name: "scene_2_2_1", active: "2_2", left: "18.59", top: "5.68", type: 'cityname', title: '天津' },
        { name: "scene_2_3_1", active: "2_3", left: "15.78", top: "6.15", type: 'cityname', title: '河北' },
        { name: "scene_2_4_1", active: "2_4", left: "14.95", top: "3.54", type: 'cityname', title: '山西' },
        { name: "scene_2_5_2", active: "2_5", left: "16.88", top: "3.70", type: 'cityname', title: '内蒙古' },
        { name: "scene_2_6_1", active: "2_6", left: "19.58", top: "3.23", type: 'cityname', title: '辽宁' },
        { name: "scene_2_7_1", active: "2_7", left: "20.57", top: "4.74", type: 'cityname', title: '吉林' },
        { name: "scene_2_8_1", active: "2_8", left: "20.57", top: "6.15", type: 'cityname', title: '黑龙江' },
        { name: "scene_2_9_1", active: "2_9", left: "24.84", top: "7.24", type: 'cityname', title: '上海' },
        { name: "scene_2_10_1", active: "2_10", left: "24.22", top: "3.80", type: 'cityname', title: '江苏' },
        { name: "scene_2_11_1", active: "2_11", left: "26.82", top: "3.85", type: 'cityname', title: '浙江' },
        { name: "scene_2_12_1", active: "2_12", left: "28.80", top: "4.69", type: 'cityname', title: '安徽' },
        { name: "scene_2_13_1", active: "2_13", left: "28.96", top: "6.77", type: 'cityname', title: '福建' },
        { name: "scene_2_14_1", active: "2_14", left: "25.68", top: "9.58", type: 'cityname', title: '江西 ' },
        { name: "scene_2_15_1", active: "2_15", left: "24.84", top: "11.35", type: 'cityname', title: '山东' },
        { name: "scene_2_16_1", active: "2_16", left: "25.94", top: "12.97", type: 'cityname', title: '河南' },
        { name: "scene_2_17_1", active: "2_17", left: "28.07", top: "13.91", type: 'cityname', title: '湖北' },
        { name: "scene_2_18_1", active: "2_18", left: "28.49", top: "11.88", type: 'cityname', title: '湖南' },
        { name: "scene_2_19_1", active: "2_19", left: "29.27", top: "9.84", type: 'cityname', title: '广西' },
        { name: "scene_2_20_1", active: "2_20", left: "33.70", top: "6.51", type: 'cityname', title: '广东' },
        { name: "scene_2_21_1", active: "2_21", left: "34.84", top: "9.43", type: 'cityname', title: '香港' },

        { name: "scene_2_22_1", active: "2_22", left: "32.76", top: "10.36", type: 'cityname', title: '澳门' },
        { name: "scene_2_23_1", active: "2_23", left: "32.34", top: "13.39", type: 'cityname', title: '重庆' },
        { name: "scene_2_24_1", active: "2_24", left: "35.21", top: "12.19", type: 'cityname', title: '四川' },
        { name: "scene_2_25_1", active: "2_25", left: "34.64", top: "17.29", type: 'cityname', title: '西藏' },
        { name: "scene_2_26_1", active: "2_26", left: "35.21", top: "21.41", type: 'cityname', title: '陕西' },
        { name: "scene_2_27_1", active: "2_27", left: "35.00", top: "24.17", type: 'cityname', title: '云南' },
        { name: "scene_2_28_0", active: "2_28", left: "32.45", top: "30.05", type: 'cityname', title: '海南' },
        { name: "scene_2_29_1", active: "2_29", left: "32.50", top: "26.82", type: 'cityname', title: '贵州' },
        { name: "scene_2_30_1", active: "2_30", left: "32.19", top: "22.40", type: 'cityname', title: '甘肃' },
        { name: "scene_2_31_1", active: "2_31", left: "33.13", top: "16.88", type: 'cityname', title: '青海' },
        { name: "scene_2_32_1", active: "2_32", left: "29.58", top: "18.49", type: 'cityname', title: '新疆' },

        { name: "scene_2_33_1", active: "2_33", left: "28.70", top: "17.03", type: 'cityname', title: '宁夏' },
        { name: "scene_3_1_1", active: "3_1", left: "25.5",
    top: "17", type: 'tagnamenoicon', title: '展望展区' },
        { name: "scene_0_0_1", active: "0_0", left: "18", top: "30", type: 'tagnamenoicon', title: '室外展区' },
        { name: "scene_4_1_1", active: "4_1", left: "4.6", top: "29.8", type: 'tagnamenoicon', title: '互动展区' },
      ],
      outMenu: [
        {
          title: "序厅",
          label: "",
          name: "scene_0_1_1", active: "0_1",
          class: "xu"
        },
      ],
      centerMenu: [
        {
          title: "第一单元",
          label: "经济建设奋楫扬帆\u3000谱写高质量发展新篇章",
          name: "scene_1_1_0", active: "1_1",
        },
        {
          title: "第二单元",
          label: "全面深化改革不断向广度和深度进军\u3000中国特色社会主义制度更加成熟更加定型",
          name: "scene_1_2_1", active: "1_2",
        },
        {
          title: "第三单元",
          label: "积极发展全过程人民民主\u3000建设社会主义民主政治",
          name: "scene_1_3_1", active: "1_3",
        },
        {
          title: "第四单元",
          label: "着力推进新时代全面依法治国\u3000开辟良法善治新境界",
          name: "scene_1_4_1", active: "1_4",
        },
        {
          title: "第五单元",
          label: "坚定文化自信\u3000建设社会主义文化强国",
          name: "scene_1_5_1", active: "1_5",
        },
        {
          title: "第六单元",
          label: "全面推进社会建设\u3000不断满足人民美好生活向往",
          name: "scene_1_6_1", active: "1_6",
        },
        {
          title: "第七单元",
          label: "坚持人与自然和谐共生\u3000美丽中国建设迈出重大步伐",
          name: "scene_1_7_1", active: "1_7",
        },
        {
          title: "第八单元",
          label: "坚持走中国特色强军之路\u3000全面推进国防和军队现代化",
          name: "scene_1_8_1", active: "1_8",
        },
        {
          title: "第九单元",
          label: "全面践行总体国家安全观\u3000开创新时代国家安全新局面",
          name: "scene_1_9_1", active: "1_9",
        },
        {
          title: "第十单元",
          label: "坚持“一国两制”\u3000推进祖国统一",
          name: "scene_1_10_1", active: "1_10",
        },
        {
          title: "第十一单元",
          label: "坚持推动构建人类命运共同体\u3000开创中国特色大国外交新局面",
          name: "scene_1_11_1", active: "1_11"
        },
        {
          title: "第十二单元",
          label: "全面从严治党\u3000保持党的生机活力",
          name: "scene_1_12_1", active: "1_12",
        },
      ],
      placeMenu: [
        {
          title: "北京",
          label: "",
          name: "scene_2_1_1", active: "2_1",
        },
        {
          title: "天津",
          label: "",
          name: "scene_2_2_1", active: "2_2",
        },
        {
          title: "河北",
          label: "",
          name: "scene_2_3_1", active: "2_3",
        },
        {
          title: "山西",
          label: "",
          name: "scene_2_4_1", active: "2_4",
        },
        {
          title: "内蒙古",
          label: "",
          name: "scene_2_5_2", active: "2_5",
        },
        {
          title: "辽宁",
          label: "",
          name: "scene_2_6_1", active: "2_6",
        },
        {
          title: "吉林",
          label: "",
          name: "scene_2_7_1", active: "2_7",
        },
        {
          title: "黑龙江",
          label: "",
          name: "scene_2_8_1", active: "2_8",
        },
        {
          title: "上海",
          label: "",
          name: "scene_2_9_1", active: "2_9",
        },
        {
          title: "江苏",
          label: "",
          name: "scene_2_10_1", active: "2_10",
        },
        {
          title: "浙江",
          label: "",
          name: "scene_2_11_1", active: "2_11",
        },
        {
          title: "安徽",
          label: "",
          name: "scene_2_12_1", active: "2_12",
        },
        {
          title: "福建",
          label: "",
          name: "scene_2_13_1", active: "2_13",
        },
        {
          title: "江西",
          label: "",
          name: "scene_2_14_1", active: "2_14",
        },
        {
          title: "山东",
          label: "",
          name: "scene_2_15_1", active: "2_15",
        },
        {
          title: "河南",
          label: "",
          name: "scene_2_16_1", active: "2_16",
        },
        {
          title: "湖北",
          label: "",
          name: "scene_2_17_1", active: "2_17"
        },
        {
          title: "湖南",
          label: "",
          name: "scene_2_18_1", active: "2_18"
        },
        {
          title: "广西",
          label: "",
          name: "scene_2_19_1", active: "2_19"
        },
        {
          title: "广东",
          label: "",
          name: "scene_2_20_1", active: "2_20"
        },
        {
          title: "香港",
          label: "",
          name: "scene_2_21_1", active: "2_21"
        },
        {
          title: "澳门",
          label: "",
          name: "scene_2_22_1", active: "2_22"
        },
        {
          title: "重庆",
          label: "",
          name: "scene_2_23_1", active: "2_23"
        },
        {
          title: "四川",
          label: "",
          name: "scene_2_24_1", active: "2_24"
        },
        {
          title: "西藏",
          label: "",
          name: "scene_2_25_1", active: "2_25"
        },
        {
          title: "陕西",
          label: "",
          name: "scene_2_26_1", active: "2_26"
        },
        {
          title: "云南",
          label: "",
          name: "scene_2_27_1", active: "2_27"
        },
        {
          title: "海南",
          label: "",
          name: "scene_2_28_0", active: "2_28",
        },
        {
          title: "贵州",
          label: "",
          name: "scene_2_29_1", active: "2_29",
        },
        {
          title: "甘肃",
          label: "",
          name: "scene_2_30_1", active: "2_30",
        },
        {
          title: "青海",
          label: "",
          name: "scene_2_31_1", active: "2_31",
        },
        {
          title: "新疆",
          label: "",
          name: "scene_2_32_1", active: "2_32",
        },
        {
          title: "宁夏",
          label: "",
          name: "scene_2_33_1", active: "2_33",
        }
      ],
      lastMenu:[
        {
          title: "展望展区",
          label: "",
          name: "scene_3_1_1", active: "3_1",
          class: "feature"
        },
        {
          title: "室外展区",
          label: "",
          name: "scene_0_0_1", active: "0_0",
          class: "out"
        },
        {
          title: "互动展区",
          label: "",
          name: "scene_4_1_1", active: "4_1",
          class: "hudong"
        },
      ]
    
    };
  },
  computed: {
    ...mapState('common', {
      clickedMapList: state => state.clickedMapList
    }),
    dotItem() {
      if (this.sceneName) {
        var nowSceneName = this.sceneName.split("_");
        var index = nowSceneName[1] + "_" + nowSceneName[2];
        var dotItem = ""
        this.dotDataNew.forEach(element => {
          if (element.active == index) {
            dotItem = element
          }
        });

        return dotItem
      } else {
        return ""
      }
    },
    itemTagName() {
      return function (type) {
        return type === 'tagname' || type === 'tagnamenoicon';
      }
    },
    // 地图上的点是否被点击过
    itemIsActived() {
      return function (idata) {
        const res = this.clickedMapList.filter(item => item === idata.name);
        if (res && res.length > 0) {
          return true
        } else {
          return false;
        }
      };
    },
    mapLocalDotLeft() {
      return function (dotItem) {
        // if (dotItem.type === 'tagname') {
        //   return parseInt(dotItem.left) + 'vw';
        // } else {
        //   return parseInt(dotItem.left) + 'vw';
        // }
        return parseInt(dotItem.left) + 'vw';

      }
    }
  },
  methods: {
    ...mapMutations('common', ['SET_CLICKED_MAPLIST']),
    showOrHideMap(showOrHide) {
      this.mapShow = showOrHide;
    },
    clickDot(item) {

      this['SET_CLICKED_MAPLIST'](item.name);
      this.krpano.call(
        "loadscene(" +
        item.name +
        ",null, MERGE, BLEND(1.0, easeInCubic));"
      );
      this.showOrHideMap(false)
    },
    // 分享
    openShare() {
      this.shareShow = true;
      this.$nextTick(() => {
        this.creatQRcode();
      });
    },
    closeShare() {
      this.shareShow = false;
    },
    creatQRcode() {
      var locationUrl = window.location.href;

      var qrcode = new QRCode(this.$refs.qrcode, {
        text: locationUrl,
        width: 100,
        height: 100,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    // 分享end
    // 点赞展示
    canvasShow(time) {
      var that = this;
      document.querySelector("#canvas_id").style.display = "block";
      that.numShow = true;
      if (time) {
        clearTimeout(time);
      }
      return (time = setTimeout(() => {
        document.querySelector("#canvas_id").style.display = "none";
        that.numShow = false;
        clearTimeout(time);
      }, 3000));
    },
    // 收起、展开
    showOrHide() {
      this.uiShowOrHide = !this.uiShowOrHide;
      this.$emit("uiToggle", this.uiShowOrHide);
    },
    //音频播放
    playBgMusic(val) {
      if (val) {
        this.audio.play();
        sessionStorage.bgmusic = "play";
        this.audio.addEventListener("ended",function(){
            sessionStorage.bgmusicEnd = "true"
          })
        this.audio.addEventListener("playing", function () { });
      } else {
        this.audio.pause();
        sessionStorage.bgmusic = "pause";
      }
    },
    triggerBgMusic() {
      if (sessionStorage.bgmusic && sessionStorage.bgmusic === "play" && sessionStorage.bgmusicEnd == "false") {
        this.playBgMusic(false);
        this.musicPlay = false;
      } else {
        this.playBgMusic(true);
        this.musicPlay = true;
      }
    },

    giveZan() {
      var that = this;
      let scene_name = this.krpano.get("xml.scene");
      let sceneShortName = scene_name.split("_")[1] + "_" + scene_name.split("_")[2]
      let activeCity = cityInfo.filter(item => item.sceneName == sceneShortName)[0]
      if (!activeCity) {
        const random = (min, max) => Math.floor(Math.random() * (max - min) + min); //随机数方法
        let index = random(0, cityInfo.length); //生成一个从最小值为0 最大值为数组长度的随机数

        activeCity = cityInfo[index]
      }

      giveThumbsUp(15967, activeCity.groupId, activeCity.id)
    },
    mouseover(item) {

      this.dotDataNew.forEach(element => {
        if (element.name == item.name) {
          this.chosedItem = element
        }
      });
      this.isHover = true;
    },
    mouseLeave(item) {
      this.isHover = false;
    },
    // 专题片
    openSpecialSub(){
      this.showSpecial = true;
    },
    closeSpecialSub(){
     
      this.showSpecial = false
    }
  },
  mounted() {

    
    let startscene = this.$route.query.startscene
    if (startscene) {
      this.$nextTick(()=>{
        this.krpano.call(
        "loadscene(" +
        startscene +
        ",null, MERGE, BLEND(1.0, easeInCubic));"
      );
      })
  
    }


   


    let _this = this;
    // 点赞飘心
    var assets = [
      "./images/zan/1.png",
      "./images/zan/2.png",
      "./images/zan/3.png",
      "./images/zan/4.png",
      "./images/zan/5.png",
      "./images/zan/6.png",
      "./images/zan/7.png",
    ];
    assets.forEach(function (src, index) {
      assets[index] = new Promise(function (resolve) {
        var img = new Image();
        img.onload = resolve.bind(null, img);
        img.src = src;
      });
    });
    Promise.all(assets).then(function (images) {
      var random = {
        uniform: function (min, max) {
          return min + (max - min) * Math.random();
        },
        uniformDiscrete: function (i, j) {
          return i + Math.floor((j - i + 1) * random.uniform(0, 1));
        },
      };
      var stage = new BubbleHearts();
      var canvas = stage.canvas;
      canvas.width = 170;
      canvas.height = 300;
      canvas.id = "canvas_id";
      canvas.style["width"] = "8.8vw";
      canvas.style["height"] = "15.30vw";
      document.getElementsByClassName("zan-btn")[0].appendChild(canvas);

      let time = null;
      document.getElementsByClassName("zan-btn")[0].addEventListener(
        "click",
        function () {
          // console.log(time);
          time = _this.canvasShow.apply(this, [time]);
          _this.giveZan();

          stage.bubble(images[random.uniformDiscrete(0, images.length - 1)]);
        },
        false
      );
    });
    // 点赞飘心 end
    // 声音控制
    this.audio = document.querySelector("#audio");
 

    //----------处理页面激活------------
    var hiddenProperty =
      "hidden" in document
        ? "hidden"
        : "webkitHidden" in document
          ? "webkitHidden"
          : "mozHidden" in document
            ? "mozHidden"
            : null;
    var visibilityChangeEvent = hiddenProperty.replace(
      /hidden/i,
      "visibilitychange"
    );
    var onVisibilityChange = function () {
      var videoPlayState1 = _this.krpano.get("videoPlayState1");

      if (!document[hiddenProperty]) {
      
        if (sessionStorage.bgmusic === "play"  && sessionStorage.bgmusicEnd == "false") {
          _this.audio.play();
          _this.audio.addEventListener("ended",function(){
            sessionStorage.bgmusicEnd = "true"
          })
        }
        if (videoPlayState1) {
          _this.krpano.call('hotspot["videospot"].play()');
        }
      } else {
        _this.audio.pause();
        if (videoPlayState1 !== undefined && videoPlayState1 !== null) {
          _this.krpano.call('hotspot["videospot"].pause()');
        }
      }
    };
    document.addEventListener(visibilityChangeEvent, onVisibilityChange);
    
    window.triggerBgMusic = this.triggerBgMusic





  },
};
</script>

<style lang="scss" scoped>
@mixin background-com {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

$menu-color: #c9151e;
$menu-active-color: #840007;

.map-area-box {
  position: absolute;
  top: 90px;
  right: 40px;
  width: 286px;

  opacity: 1;
  transition: right 0.5s ease-in-out, opacity 0.5s ease-in-out;
  transition-delay: 0.3s;

  &.ui-hide {
    right: -400px;
    opacity: 0;
    transition-delay: 0s;
  }
}

.map-open-btn {
  width: 41px;
  height: 227px;
  position: absolute;
  top: 87px;
  right: -100px;
  opacity: 0;
  background-image: url("../assets/img/map-open.png");
  @include background-com();
  transition: right 0.5s ease-in-out, opacity 0.5s ease-in-out;
  transition-delay: 0s;
  cursor: pointer;

  &.ui-show {
    right: 0;
    opacity: 1;
    transition-delay: 0.3s;
  }
}

.map-icon {
  width: 286px;
  height: 286px;
  background-image: url("../assets/img/map-icon.png");

  cursor: pointer;
  @include background-com();

}

.map-scale-btn {
  width: 36px;
  height: 36px;
  background-image: url("../assets/img/scale-btn.png");
  cursor: pointer;
  position: absolute;
  top: 188px;
  left: -44px;

  @include background-com();

  &:hover {
    background-image: url("../assets/img/scale-btn-hover.png")
  }
}

.map-close-btn {
  width: 24px;
  height: 110px;
  background-image: url("../assets/img/map-close.png");
  @include background-com();
  position: absolute;
  top: 20px;
  left: -24px;
  cursor: pointer;
}

.map-operation-box {
  width: 100%;

  padding: 10px;
  display: flex;
  justify-content: space-around;

  .map-operation-btn {
    width: 52px;
    height: 52px;
    cursor: pointer;
    @include background-com();
    &.video-btn{
      background-image: url("../assets/img/video-icon.png");
      &:hover{
        background-image: url("../assets/img/video-icon-hover.png");
      }
    }
    &.voice-btn {
      background-image: url("../assets/img/voice-icon.png");

      &:hover {
        background-image: url("../assets/img/voice-icon-hover.png");
      }

      &.off {
        background-image: url("../assets/img/voice-off-icon.png");

        &:hover {
          background-image: url("../assets/img/voice-off-icon-hover.png");
        }
      }
    }

    &.share-btn {
      background-image: url("../assets/img/share-icon.png");

      &:hover {
        background-image: url("../assets/img/share-icon-hover.png");
      }
    }

    &.zan-btn {
      background-image: url("../assets/img/heart-icon.png");
      position: relative;

      &:hover {
        background-image: url("../assets/img/heart-icon-hover.png");
      }

      .like-num {
        color: #ffffff;
        font-size: 0.26rem;
        top: -0.5rem;
        width: 100%;
        position: absolute;
        transform: skewX(42deg) translateX(-100%);
      }
    }
  }
}

.map-box {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 200;

  .map-box-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba($color: #000000, $alpha: 0.8);
  }

  .map-content {
    width: 1757px;
    height: 911px;
    position: absolute;
    background-image: url("../assets/img/map/map-bg.png");
    @include background-com();
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .map-img {
      width: 705px;
      height: 801px;
      @include background-com();
      background-image: url("../assets/img/map/map-content-bg.png");
      position: absolute;
      top: 52px;
      left: 63px;
    }

    .map-dot-box {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;

      .map-dot {
        width: 0.2rem;
        height: 0.2rem;
        border-radius: 0.5rem;
        background-color: #ffffff;
        box-shadow: 0 0 3px #ffffff;
        position: absolute;
        margin-left: -0.15rem;
        margin-top: -0.15rem;
        cursor: pointer;

        &.first {
          background-color: #8b0302;
        }

        &:hover {
          background-color: #ffae00;
        }
      }

      .map-dot-new {
        position: absolute;
        display: inline-block;

        font-family: PingFang SC;
        width: 10px;
        height: 10px;

        margin-left: -5px;


        &.first {
          color: #9F9F9F;
        }

        &:hover {
          color: #9F9F9F;

          .map-dot-index {
            border-color: #9F9F9F;
          }
        }

        &:active {
          color: #9F9F9F;

          .map-dot-index {
            border-color: #9F9F9F;
          }
        }

        &:visited {
          color: #9F9F9F;

          .map-dot-index {
            border-color: #9F9F9F;
          }
        }
      }

      .map-dot-white {
        color: #fff;

        .map-dot-index {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 0;
          left: -38px;
          width: 32px;
          height: 32px;
          border: 2px solid #fff;
          border-radius: 50%;
        }
      }

      .map-dot-isActived {
        color: #9F9F9F;

        .map-dot-index {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 0;
          left: -38px;
          width: 32px;
          height: 32px;
          border: 2px solid #9F9F9F;
          border-radius: 50%;
        }
      }
    }

    .map-local-dot {
      width: 24px;
      height: 23px;
      position: absolute;
      background-image: url("../assets/img/map/map-position-icon.png");
      // background-image: url("../assets/img/little-location-icon.png");
      @include background-com();
      margin-left: -8px;
      margin-top: -8px;
    }

    .map-menu-box {
      width: 886px;
      height: 800px;
      position: absolute;
      left: 798px;
      top: 54px;
      display: flex;

      .center-menu {
        width: 464px;
        margin-right: 19px;

        .center-menu-title {
          width: 100%;
          height: 43px;
          background-image: url("../assets/img/map/center-menu-title.png");
          @include background-com();
          margin-bottom: 10px;

          &.xu {
            cursor: pointer;
            background-image: url("../assets/img/map/center-menu-title-xu.png");

            &:hover,&.active {
              background-image: url("../assets/img/map/center-menu-title-xu-hover.png");
            }
          }

        }

        .center-menu-box {
          height: 650px;

        }

        .center-menu-item {
          width: 100%;
          display: flex;
          cursor: pointer;
          text-align: left;
          margin-bottom: 10px;

          .center-menu-index {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            background-color: $menu-color;
            color: #ffffff;
            font-weight: 800;
            font-size: 14px;
            text-align: center;
            line-height: 26px;
            margin-right: 10px;
          }

          .center-menu-content {
            flex: 1;
            color: $menu-color;

            .center-menu-item-title {
              font-size: 16px;
              font-weight: 800;
              margin-bottom: 5px;
            }

            .center-menu-item-lable {
              font-size: 12px;

            }
          }

          &:hover,
          &.active {
            .center-menu-index {

              background-color: $menu-active-color;

            }

            .center-menu-content {
              color: $menu-active-color;
            }
          }

        }

      }

      .place-menu {
        width: 403px;

        .place-menu-title {
          width: 100%;
          height: 43px;
          background-image: url("../assets/img/map/place-menu-title.png");
          @include background-com();
          margin-bottom: 10px;

          &.hudong {
            cursor: pointer;
            background-image: url("../assets/img/map/place-menu-title-hu.png");

            &:hover,&.active {
              background-image: url("../assets/img/map/place-menu-title-hu-hover.png");
            }
          }
          &.out {
            cursor: pointer;
            background-image: url("../assets/img/map/center-menu-title-out.png");

            &:hover,&.active {
              background-image: url("../assets/img/map/center-menu-title-out-hover.png");
            }
          }
          &.feature {
            cursor: pointer;
            background-image: url("../assets/img/map/place-menu-title-featrue.png");

            &:hover,&.active {
              background-image: url("../assets/img/map/place-menu-title-featrue-hover.png");
            }
          }
        }
        .place-menu-scroll-box{
          height: 460px !important;
        }
        .place-menu-box {
          display: flex;
          flex-wrap: wrap;
          padding: 0 20px;
        }

        .place-menu-item {
          display: flex;
          width: 100px;
          margin-right: 20px;
          margin-bottom: 20px;
          cursor: pointer;

          &:nth-child(3n) {
            margin-right: 0;

          }

          .place-menu-index {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: $menu-color;
            color: #ffffff;
            font-weight: 800;
            font-size: 12px;
            text-align: center;
            line-height: 20px;
            margin-right: 10px;
          }

          .place-menu-lable {

            font-size: 16px;
            font-weight: 800;
            text-align: justify;
            text-justify: distribute-all-lines;
            text-align-last: justify;
            white-space: nowrap;
            overflow: hidden;
            flex: 1;
            color: $menu-color;
          }

          &:hover,
          &.active {
      

            .place-menu-index {
              background-color: $menu-active-color;
            }
            .place-menu-lable{
              color: $menu-active-color;
            }
          }
        }
      }
    }

  }

  .close-map {
    color: #ffffff;
    font-size: 16px;
    position: absolute;
    width: 55px;
    height: 55px;
    top: 10px;
    right: 15px;
    // top: 879px;
    // left:981px;
    cursor: pointer;
    background: url('~@/assets/img/map/map-close-icon.png') no-repeat center;
    background-size: cover;
    z-index: 99;
  }
}

.qrcode-box {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;

  .qrcode-bg {
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.6);
  }

  .qrcode-close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 40px;
    height: 40px;
    background: url("../assets/img/close-btn.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 100;
  }

  .qrcode {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.8);
    width: 400px;
    height: 500px;
    // width: 4rem;
    // height: 5rem;
    position: absolute;
    background-color: #fff;
    // border-radius: 0.2rem;
    border-radius: 20px;
    // padding-top: 0.85rem;
    padding-top: 85px;
    box-sizing: border-box;
    text-align: center;

    .qrcode-img {
      // width: 3rem;
      // height: 3rem;
      width: 300px;
      height: 300px;
      margin: 0 auto;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .qrcode-text {
    font-size: 30px;
    margin-top: 20px;
    color: #000;
  }
}
</style>
<style>
#canvas_id {
  position: absolute;
  bottom: 55px;
  left: -58px;

  display: none;
}

.qrcode-img img {
  width: 100%;
  height: 100%;
}

.center-menu-box .el-scrollbar__wrap,
.place-menu-scroll-box .el-scrollbar__wrap {
  overflow-x: hidden;
}

</style>